/** @jsx jsx */
import { jsx } from '@emotion/core';
import { customInstallmentsSelectStyles, IndexHeader, IndexRemove } from '../../../styles';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import { useFormikContext } from 'formik';
import { Grid, Divider } from 'semantic-ui-react';
import CurrencyField from '../../../../../../ui/CurrencyField';
import { memo, useEffect, useState } from 'react';
import axios from 'axios';

const Abatement = props => {
  const [abatementTypes, setAbatementTypes] = useState([]);
  const getAbatementTypes = async () => {
    const { data } = await axios.get(`/api/property/GetDropdownTypes/${2}/${2}`);
    setAbatementTypes(data);
  };
  const addAbatement = async e => {
    if (e.__isNew__) {
      await axios.post(`/api/property/AddDropdownType`, {
        type: e.label,
        locationTypeId: 2,
        dropdownTypeId: 2,
      });
      getAbatementTypes();
    }
    props.setFieldValue(`propertyInfo.abatements[${props.index}].exemption`, e);
  };
  useEffect(() => {
    getAbatementTypes();
  }, []);
  return (
    <Grid>
      <Grid.Row columns={3}>
        <Grid.Column width={4}>
          <IndexHeader> Abatement #{props.index + 1}</IndexHeader>
        </Grid.Column>
        <Grid.Column width={10}>
          <Divider />
        </Grid.Column>
        <Grid.Column width={2} textAlign="right">
          <IndexRemove onClick={() => props.remove(props.index)}>Remove</IndexRemove>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column>
          <span
            css={{
              marginBottom: 8,
              display: 'inline-block',
            }}
          >
            Abatement
          </span>
          <CreatableSelect
            options={abatementTypes}
            value={props.propertyInfo.abatements[props.index].exemption}
            onChange={e => addAbatement(e)}
            styles={customInstallmentsSelectStyles}
          />
        </Grid.Column>
        <Grid.Column>
          <CurrencyField
            showCheckbox
            label="Amount"
            width="100%"
            value={props.propertyInfo.abatements[props.index].amount}
            onChange={e => props.setFieldValue(`propertyInfo.abatements[${props.index}].amount`, e)}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default memo(Abatement);
